import { createDetailedValidator } from 'typecheck.macro';
import { makeAlgoliaIndex } from '../../schema/public-algolia/AlgoliaIndex';
import { useAlgoliaAutoComplete } from './useAutoComplete';

const AllergensIndex = makeAlgoliaIndex(
  'Allergens',
  createDetailedValidator<{ allergen: string }>(),
);

export const useAutoCompleteAllergens = (input?: string) =>
  useAlgoliaAutoComplete(AllergensIndex, input).map(({ allergen }) => ({
    label: allergen,
    value: allergen,
  }));
